import { Component, OnInit } from '@angular/core';
import { BpgAdminServices } from '../../bpg-admin/bpg-admin-services';
import { SelfService } from '../../bpg-self-services/self-services.service.ts';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LandingPaginationDTO } from "../../bpg-common/services/data.services";
import { ConstantValues } from '../../bpg-common/models/bpg-constants';

import { Router } from '@angular/router';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {
  LandingPaginationDTO: LandingPaginationDTO = new LandingPaginationDTO();
  landingDto: any;
  adminData: any;
  userList: any;
  name: any;
  email: any;
  workId: any;
  user: string = null;
  role: string = null;
  roleName = "Super Admin";
  userFirstName: string = null;
  noDataFound: boolean;
  alertSuccess: boolean;
  alertFailure: boolean;
  alertError: boolean;
  deleteSuccess: boolean;
  errorMsg: any;
  msg1: string;
  method: string;
  param: string;
  loginData: any;
  loginUserId: string;
  chapterId: any;
  createdBy: any;
  createdDateTime: any;
  modifiedBy: any;
  modifiedDateTime: any;
  userId: any;
  adminId: any = localStorage.getItem('adminId');
  numberOfElements:number;
  currentPage = 0;
  currentNumberOfElements:number = ConstantValues.pageLimit;
  totalPages = 0;
  tableShow: any;
  limit: number = ConstantValues.pageLimit;
  currentShowingElements: number = ConstantValues.pageLimit;
  searchKey: any;
  searchTerm : any;
  noUser : boolean;
  userFound : boolean;
  search : boolean;
  loginDetails: any  = JSON.parse(localStorage.getItem("loginData"));
  timeOutError: boolean;
  timeoutErrorMessage : string = ConstantValues.timeoutErrorMessage;
  roleId : any = 1;
  constructor(private readonly userService: SelfService, 
              private readonly adminService: BpgAdminServices, 
              private readonly spinner: Ng4LoadingSpinnerService,
              
              private readonly router: Router,
              private readonly environment : EnvironmentConfiguration
              ){ }

  ngOnInit() {
    if(this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod'){
 if(localStorage.getItem('loginData') === null || localStorage.getItem('loginData') === undefined ){
      this.router.navigate(['/log-out']);
      }
    }

    if (localStorage.getItem('logOutFlag') === "true"){
        this.router.navigate(['/log-out']); 
    }
    localStorage.removeItem('searchedEventsCaledarItems');
    this.spinner.show();

    if(this.adminId !== '1')
    {
      this.router.navigate(['/site-home']);
    }


    sessionStorage.removeItem("MembershipData");
    
    this.landingDto = {
      "filter": { },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }

    this.LandingPaginationDTO.sortProperty = "user_first_name";
    this.LandingPaginationDTO.size = ConstantValues.pageLimit;
    this.LandingPaginationDTO.sortDirection = "ASC";

 this.spinner.show();

    this.loginData = JSON.parse(localStorage.getItem('loginData'));
    this.createdBy = this.loginData.userId;
    this.modifiedBy = this.loginData.userId;

    this.createdDateTime = new Date();
    this.modifiedDateTime = new Date();


    this.listAdmins();

    this.loginUserId = this.loginData.userId;
    
    setTimeout(function () {
      this.spinner.hide();
    }.bind(this), 500);
  }


  /** to list admins in table
  * @class AdminComponent
  * @method listAdmins
  */
 

  listAdmins() {
    this.timeOutError = false;
    this.spinner.show();
    this.adminService.getAllAdmins(this.LandingPaginationDTO).subscribe(data => {    
      this.adminData = data.content;
      this.spinner.hide();
      if (this.adminData.length === 0) {
        this.tableShow = false;
        this.noDataFound = true;
        setTimeout(function () {
          this.spinner.hide();
        }.bind(this), 5000);
      }
    else {
        this.tableShow = true;
        this.noDataFound = false;
      }
      this.numberOfElements = data.totalElements;
    },
    err => {
      if(err.value.statusText === ConstantValues.unknownError){
        this.timeOutError = true;
      }
    });
  }

  /** to list users other than admins
  * @class AdminComponent
  * @method getUserList
  */

  getUserList() {
    this.timeOutError = false;
    this.landingDto.filter = {};
    this.landingDto.filter.leadershipPosition =  "USER";
    this.userService.getUserDropDown(this.landingDto).subscribe(data => {
      this.userList = data;
      if(this.userList.length === 0){
        setTimeout(() => {    
          window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        },500);
        this.noUser = true;
        if(this.deleteSuccess === true  ){
          this.noUser = false;
        }
      } else{   
        if(this.search){
          setTimeout(() => {    
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
          },500);
        this.userFound = true; 

        } 
      this.userList.map((i) => { i.userFirstName = `${i.userFirstName} ${i.userLastName}`; return i; })
      }   


    }, err => {
      if(err.value.statusText === ConstantValues.unknownError){
        this.timeOutError = true;
      }
    });
  }

  findbyEmail(e){
    const text = e.target.value;
    if(text.length>2){
     this.searchTerm = text;
     this.searchBy();
    }else{
      this.userList = [];
    }
  }
  /** When select a user Populate the user details such as email and workId 
* @class AdminComponent
* @method getUserList
*/

  userSelection(selectedUser) {
    for (const user of this.userList) {
      if (user != null) {
        if (selectedUser.userId === user.userId) {
          this.userId = user.userId;
          this.name = user.userFirstName;
          this.email = user.emailId;
          this.workId = user.workdayId;
        }
      }
    }
    this.userFound = false;
  }

  /** When select a role such as super admin or naac representative 
* @class AdminComponent
* @method roleSelection
*/

  roleSelection(role) {
    if (role.roleName === "Super Admin") {
      this.adminId = '1';
    }
    else if (role.roleName === "NAAC Admin") {
      this.adminId = '4';
    }
  }
/**to submit admin
  * @class AdminComponent
  * @method submit
  */

 submit() {
  this.timeOutError = false;
  const data = {     
    "createdBy": this.createdBy,
    "createdDateTime": this.createdDateTime,
    "isActive": true,
    "modifiedBy": this.modifiedBy,
    "modifiedDateTime": this.modifiedDateTime,
    "userId": this.userId,
    "userRoleMappingId": 0,
    "adminId": this.roleId,
  }
  this.adminService.saveAdmin(data).subscribe(data => {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    if (data !== null && data.body.message === undefined) {
      this.alertSuccess = true;
      this.search = false;        
    }
    else if( data.body.message !== undefined) {
      this.errorMsg = data.body.message.split(":")[0];
      this.alertFailure = true;
      this.search = false;   
    }
    else{
      this.alertError = true;
    }   
    this.listAdmins();
    this.getUserList();
  },
  err => {
    if(err.value.statusText === ConstantValues.unknownError){
      this.timeOutError = true;
    }
  }); 
  
}

  /** to add new admin
  * @class AdminComponent
  * @method addAdmin
  */
  onSubmit() {
    this.clearError();     
    this.method = "submit";
    this.param = '';
    this.msg1 = "Are you sure you want to add this user as admin ?";
  }

  /**to delete admin
  * @class AdminComponent
  * @method delete
  */

  delete(data) {
    this.clearError();
    this.method = "deleteAdmin";
    this.param = data;
    this.msg1 = "Are you sure you want to delete this admin ?";
  }

  deleteAdmin(data) {
    this.timeOutError = false;
    this.adminService.deleteAdmin(data.userId).subscribe(_data => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      this.deleteSuccess = true;
      this.noUser = false;
      this.search = false;   
      this.listAdmins();
      this.getUserList();      
    },
    err => {
      if(err.value.statusText === ConstantValues.unknownError){
        this.timeOutError = true;
      }
    });
    
  }

  resetClick(){
    this.noDataFound =false;
    this.method = "resetAdmin";
    this.param = '';
    this.msg1 = "Your current changes will be discarded. Do you want to continue ?";
  }

  /** For resetting the skill form
   * @method resetSkill
   */
  resetAdmin() {
    this.userFirstName = null;   
    this.name = '';     
    this.email = '';    
    this.workId = ''; 
    this.searchTerm=null;
    this.LandingPaginationDTO.searchTerm = '';
    this.searchKey =null;
    this.clearError();
    this.listAdmins();
  }



  /** For filtering data by current page 
   * @class AdminComponent
   * @method pageChanged
   * @params event
   */
  pageChanged(event) {
    this.clearError();
    this.LandingPaginationDTO.page = event - 1;
    this.currentPage = event;

    if ((this.currentPage * this.limit) < this.numberOfElements) {
      this.currentShowingElements = this.currentPage * this.limit;
    } else if ((this.currentPage * this.limit) >= this.numberOfElements) {
      this.currentShowingElements = this.numberOfElements;
    }
    this.listAdmins();
  }

    /** For sorting the table through columns
   * @class AdminComponent
   * @method sortMe
   */

  public sortMe(sortingby) {
    this.clearError();
    if (this.LandingPaginationDTO.sortDirection === "ASC") {
      this.LandingPaginationDTO.sortDirection = "DESC";
      document.getElementById(sortingby + "1").classList.add("fading");
      document.getElementById(sortingby + "2").classList.remove("fading");
    } else {
      this.LandingPaginationDTO.sortDirection = "ASC";
      document.getElementById(sortingby + "2").classList.add("fading");
      document.getElementById(sortingby + "1").classList.remove("fading");
    }

    this.LandingPaginationDTO.sortProperty = sortingby;
    this.listAdmins();
  }

     /** For searching the table through keywords
   * @class AdminComponent
   * @method searchMe
   */
  searchMe() {  
    this.clearError();
    this.searchKey = (this.searchKey) ? this.searchKey : '';
    this.LandingPaginationDTO.page = 0;
    this.LandingPaginationDTO.searchTerm = this.searchKey;
    this.currentPage = 1;
    this.listAdmins();
  }

     /** For searching the table through search term
   * @class AdminComponent
   * @method searchBy
   */
  searchBy() {
    this.deleteSuccess = false;

    this.clearError();
    this.spinner.show(); 
    this.search = true;  
    this.searchTerm = (this.searchTerm) ? this.searchTerm : '';
    this.landingDto.searchTerm = this.searchTerm;
    this.getUserList();    
    this.spinner.hide();   
  }

   /** For clearing errors
   * @class AdminComponent
   * @method clearError
   */
  clearError() {
    this.noUser = false;
    this.alertSuccess = false;
    this.alertFailure = false;
    this.deleteSuccess = false;
    this.userFound = false; 
    this.alertError = false;
    this.noDataFound = false;
  }

}
